import { call, put, takeLatest, select } from 'redux-saga/effects';
import { get } from 'lodash';
import pickBy from 'lodash/pickBy';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { GET } from '../consts/Methods';
import { getSortParams } from '../helpers/utils';
import { FETCH_IN_REALIZATION, FETCH_IN_REALIZATION_SUCCESS, FETCH_IN_REALIZATION_FAIL } from '../redux/InRealization';
import { SET_LOADER } from '../redux/Loader';

function* getInRealizationFlow() {
  try {
    yield put(SET_LOADER({ value: true, }));
    const sortData = yield select((state) => get(state, ['tables', 'in_realization', 'sort']));
    const queryValue = yield select((state) => get(state, ['tables', 'in_realization', 'queryValue']));
    const limitValue = yield select((state) => get(state, ['tables', 'in_realization', 'rowsPerPage']));
    const page = yield select((state) => get(state, ['tables', 'in_realization', 'page']));
    const vehicleType = yield select((state) => state.vehicleType.vehicleType);

    const params = pickBy(
      {
        ...getSortParams(sortData),
        query: queryValue,
        limit: limitValue,
        page,
      },
      (val) => Boolean(val)
    );

    const endpoint = `${apiRoot}/${vehicleType}/offers/in_realization`;
    const offers = yield call(apiCall, { method: GET, endpoint, params, });
    yield put(FETCH_IN_REALIZATION_SUCCESS(offers));
  } catch (error) {
    yield put(FETCH_IN_REALIZATION_FAIL(error));
  } finally {
    yield put(SET_LOADER({ value: false, }));
  }
}

export default function* GetInRealization() {
  yield takeLatest(FETCH_IN_REALIZATION, getInRealizationFlow);
}
